
import { useState } from 'react';
import { ActiveDirectoryConfig } from '../../system/types';

export function useActiveDirectoryState() {
  const [adConfig, setAdConfig] = useState<ActiveDirectoryConfig>({
    id: '1',
    name: 'Corporate AD',
    domain: 'jspark.corp',
    server: 'ad.jspark.corp',
    port: '389',
    baseDN: 'dc=jspark,dc=corp',
    username: 'ad-service',
    status: 'disconnected',
    syncSchedule: 'daily',
    lastSync: ''
  });

  const [autoSync, setAutoSync] = useState(true);

  const handleConfigChange = (field: keyof ActiveDirectoryConfig, value: string) => {
    setAdConfig({
      ...adConfig,
      [field]: value
    });
  };

  const handleConnect = () => {
    // Simulate a connection
    setAdConfig({
      ...adConfig,
      status: 'connected',
      lastSync: new Date().toISOString()
    });
  };

  const handleDisconnect = () => {
    // Simulate a disconnection
    setAdConfig({
      ...adConfig,
      status: 'disconnected'
    });
  };

  const handleSyncNow = () => {
    // Simulate a sync
    setAdConfig({
      ...adConfig,
      lastSync: new Date().toISOString()
    });
  };

  return {
    adConfig,
    autoSync,
    setAutoSync,
    handleConfigChange,
    handleConnect,
    handleDisconnect,
    handleSyncNow
  };
}
